import React, { useRef, useState } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FaDownload } from "react-icons/fa";
import moment from "moment";

const Certificate = ({data}) => {
  const certRef = useRef();
  const [isLoading,setisLoading] = useState(false)

  // const downloadCertificate = async () => {
  //   setisLoading(true)
  //   const element = certRef.current;
  //   const canvas = await html2canvas(element, { scale: 2 });
  //   const imgData = canvas.toDataURL("image/png");

  //   const pdf = new jsPDF("l", "mm", "a4"); // Landscape A4
  //   pdf.addImage(imgData, "PNG", 10, 10, 277, 190); // Proper scaling
  //   pdf.save("certificate.pdf");
  //   setisLoading(false)
  // };

  const downloadCertificate = async () => {
    setisLoading(true);
    const element = certRef.current;
  
    const canvas = await html2canvas(element, {
      scale: 1.5, // Reduce scale to decrease image resolution
      useCORS: true, // Ensure cross-origin images are included
      allowTaint: true,
    });
  
    const imgData = canvas.toDataURL("image/jpeg", 0.7); // Convert to JPEG with 70% quality
  
    const pdf = new jsPDF("l", "mm", "a4"); // Landscape A4
    pdf.addImage(imgData, "JPEG", 10, 10, 277, 190, "", "FAST"); // Enable compression
    pdf.save("certificate.pdf");
  
    setisLoading(false);
  };
  

  return (
    <div className="w-full flex justify1-center items1-center py1-10 bg-gray1-100">
      {/* Hidden Certificate for Export */}
      {/* <div
        ref={certRef}
        className="absolute -left-[9999px] w-[1123px] h-[794px] bg-white border1-8 border1-gray-700 shadow-lg flex"
      // style={{
      //   backgroundImage: 'url("/images/home_certificate.jpeg")', // Dummy Image
      //   backgroundSize: "cover",
      //   backgroundPosition: "center",
      // }}
      >
       
        <div className="w-1/2 p-10 flex flex-col justify-between border1-r-4 border-gray-700">
         
          <div className="">
          
            <div className="flex items-center">
              <img src="/favicon-color.png" className="w-12 h-12" />
              <h1 className="font-semibold ml-2">NEXT FUTURE AI</h1>
            </div>

           
            <h1 className="uppercase text-gray-800 mt-10">
              <span className="text-6xl font-bold">Certificate</span>
              <br />
              <span className="text-4xl border-b-2 pb-4">of Achievement</span>
            </h1>

          
            <p className="text-lg mt-16 text-gray-600 uppercase font-semibold"> 
            
              proudly presented to
            </p>

         
            <h2 className="text-6xl font-semibold text-gray-900 mt-20 ml-4 font-serif"> 
              {data?.user_id?.name}
            </h2>

          
            <p className="text-3xl text-gray-500 mt-16"> 
              For successfully completing the {data?.course_name} Course
            </p>
          </div>

          <div className="flex justify-between items-center mt-10 px-4">

            <div className="text-center flex flex-col items-center">
              <p className="text-lg font-semibold text-gray-800 mt-4 mb-1">{moment(data?.updatedAt).format("DD-MM-YYYY")}</p>
              <hr className="w-32 border-t-2 border-gray-600 mt-1" />
              <p className="text-gray-700">Date</p>
            </div>
       
            <div className="text-center flex flex-col items-center">
              <img src="/favicon-color.png" alt="Signature" className="w-32 h-12 mb-0" />
              <hr className="w-32 border-t-2 border-gray-600 mt-1" />
              <p className="text-gray-700">Signature</p>
            </div>

          </div>


        </div>

  
        <div className="w-1/2 p-10 flex ">

          <div className=" w-40 h-40">
            <img
              src="/favicon-color.png"
              alt="Award Logo"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div> */}

      <div
      ref={certRef}
      className="absolute -left-[9999px] w-[1123px] h-[794px] bg-white border-8 border-gray-700 shadow-xl flex flex-col items-center justify-between p-12"
    >
      {/* Header */}
      <div className="flex flex-col mb-6">
        <div className="flex justify-center">
          <img src="/favicon-color.png" alt="Logo" className="w-16 h-16 text-center" />
        </div>
        <h1 className="font-bold text-2xl ml-4 text-gray-800 text-center">NEXT FUTURE AI</h1>
      </div>

      {/* Title */}
      <h1 className="text-6xl font-extrabold uppercase text-gray-800 text-center">
        Certificate
      </h1>
      <h2 className="text-3xl font-semibold uppercase border-b-2 border-gray-500 pb-2 text-center">
        of Achievement
      </h2>

      {/* Recipient */}
      <p className="text-lg uppercase text-gray-600 mt-8 text-center font-semibold">
        This is proudly presented to
      </p>
      <h2 className="text-5xl font-serif font-semibold text-gray-900 mt-4 text-center">
        {data?.user_id?.name}
      </h2>

      {/* Course Completion */}
      <p className="text-2xl text-gray-500 mt-8 text-center">
        For successfully completing the <strong>{data?.course_name}</strong> Course
      </p>

      {/* Footer */}
      <div className="flex justify-between items-center w-full mt-12 px-16">
        {/* Date */}
        <div className="text-center">
          <p className="text-lg font-semibold text-gray-800">
            {moment(data?.updatedAt).format("DD-MM-YYYY")}
          </p>
          <hr className="w-40 border-t-2 border-gray-600 mt-2" />
          <p className="text-gray-700">Date</p>
        </div>

        {/* Signature */}
        <div className="text-center">
          <img src="/images/sign.png"
           alt="Signature" className="w-40 h-12 mb-2" />
          <hr className="w-40 border-t-2 border-gray-600 mt-1" />
          <p className="text-gray-700">Authorized Signature</p>
        </div>
      </div>
    </div>

      {/* Download Button */}
      <button
        onClick={downloadCertificate}
        className="px-3 py-1 bg-blue-600 text-white text-lg font-semibold rounded shadow-md flex items-center "
      >
      {
        (isLoading) ? "Downloading..": <>Download <FaDownload className="mx-2" /></>
      }
        
      </button>
    </div>
  );
};

export default Certificate;

